import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  productDetails: {
    id: 'productDetails',
    defaultMessage: 'Product details'
  }
});
